// tslint:disable
/**
 * Document generator api
 * Generate documents from templates
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Generate } from '../models';
import { GenerateResult } from '../models';
import { Variable } from '../models';
/**
 * ActApi - axios parameter creator
 * @export
 */
export const ActApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAct(id: string, body: Generate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling generateAct.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateAct.');
            }
            const localVarPath = `/document-generator/act/generate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateActMultiply(ids: Array<string>, body: Generate, options: any = {}): RequestArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling generateActMultiply.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateActMultiply.');
            }
            const localVarPath = `/document-generator/act/generate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoAct(options: any = {}): RequestArgs {
            const localVarPath = `/document-generator/act/info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActApi - functional programming interface
 * @export
 */
export const ActApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAct(id: string, body: Generate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateResult> {
            const localVarAxiosArgs = ActApiAxiosParamCreator(configuration).generateAct(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateActMultiply(ids: Array<string>, body: Generate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateResult> {
            const localVarAxiosArgs = ActApiAxiosParamCreator(configuration).generateActMultiply(ids, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoAct(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Variable>> {
            const localVarAxiosArgs = ActApiAxiosParamCreator(configuration).infoAct(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ActApi - factory interface
 * @export
 */
export const ActApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAct(id: string, body: Generate, options?: any) {
            return ActApiFp(configuration).generateAct(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {Generate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateActMultiply(ids: Array<string>, body: Generate, options?: any) {
            return ActApiFp(configuration).generateActMultiply(ids, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoAct(options?: any) {
            return ActApiFp(configuration).infoAct(options)(axios, basePath);
        },
    };
};

/**
 * ActApi - object-oriented interface
 * @export
 * @class ActApi
 * @extends {BaseAPI}
 */
export class ActApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {Generate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActApi
     */
    public generateAct(id: string, body: Generate, options?: any) {
        return ActApiFp(this.configuration).generateAct(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {Generate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActApi
     */
    public generateActMultiply(ids: Array<string>, body: Generate, options?: any) {
        return ActApiFp(this.configuration).generateActMultiply(ids, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActApi
     */
    public infoAct(options?: any) {
        return ActApiFp(this.configuration).infoAct(options)(this.axios, this.basePath);
    }

}
